/**
 * 强类型限制, 增加属性必须加上类型限制以及readonly
 * 如果没有显式定义类型, 则其他文件引用后无法提示语法
 */
type PATHS = {
	readonly DESK_SIGN: string;
	readonly DESK_SIGN_IN: string;
	readonly DESK_SIGN_UP: string;
	readonly DESK_FORGET_PASSWORD: string;

	readonly DESK_HOME: string;
	readonly DESK_NOT_FOUND: string;

	readonly RISK_WARNING: string;
	readonly RISK_WARNING_MAIN: string;
	readonly RISK_WARNING_TRADE_DETAILS: string;
	readonly RISK_WARNING_SEARCH: string;
	readonly RISK_SERVICE: string;

	readonly DESK_ACCOUNT: string;
	readonly DESK_ACCOUNT_CREATE: string;
	readonly DESK_ACCOUNT_EDIT: string;
	readonly DESK_ACCOUNT_CHANGE_PWD: string;
	readonly DESK_ACCOUNT_FIND_PWD: string;

	readonly QUERY_QUOTE: string;
	readonly QUERY_POLICY: string;
	readonly QUERY_ENDO_APPLY: string;

	readonly ENDO: string;
	readonly ENDO_INFO: string;

	readonly CLAIM: string;
	readonly CLAIM_SERVICE: string;

	readonly ROLE: string;

	readonly DESK_QUOTE_FLOW: string;
	readonly DESK_PRODUCT_QUESTIONNAIRE: string;
	readonly DESK_PRODUCT_QUOTE: string;
	
	readonly QUOTATION_DETAILS_LIABILITY: string;
	readonly POLICY_DETAILS_LIABILITY: string;
	readonly DESK_PRODUCT_DETAILS_GROUP_TRAVEL: string;
	readonly LIBILITY_PRINITING_PREMIUM: string;
	// readonly LIBILITY_PRINITING_QUOTATION: string;
	// readonly GROUP_PRINITING_QUOTATION: string;
};

export default {
	DESK_SIGN: '/desk/sign',
	DESK_SIGN_IN: '/desk/sign/in',
	DESK_SIGN_UP: '/desk/sign/up',
	DESK_FORGET_PASSWORD: '/desk/forgetPwd',

	// 桌面
	DESK_HOME: '/desk',
	DESK_NOT_FOUND: '/desk/404',

	// 风险提示
	RISK_WARNING: '/desk/risk-warning',
	RISK_WARNING_MAIN: '/desk/risk-warning/main',
	RISK_WARNING_TRADE_DETAILS: '/desk/risk-warning/trade',
	RISK_WARNING_SEARCH: '/desk/risk-warning/search',
	RISK_SERVICE: '/desk/risk-warning/service',

	//账户
	DESK_ACCOUNT: '/desk/account',
	DESK_ACCOUNT_CREATE: '/desk/account/create',
	DESK_ACCOUNT_EDIT: '/desk/account/edit',
	DESK_ACCOUNT_CHANGE_PWD: '/desk/account/change-pwd',
	DESK_ACCOUNT_FIND_PWD: '/desk/account/find-pwd',

	//查询
	QUERY_QUOTE: '/desk/query/quote',
	QUERY_POLICY: '/desk/query/policy',
	QUERY_ENDO_APPLY: '/desk/query/endo',

	//批改
	ENDO: '/desk/endo/create',
	ENDO_INFO: '/desk/endo/info/:action/:productType/:keyNo',

	//理赔
	CLAIM: '/desk/claim/create',
	CLAIM_SERVICE: '/desk/claim/claim-service',

	//角色
	ROLE: '/desk/role/create',

	// 产品投保
	DESK_QUOTE_FLOW: '/desk/product/quote',
	// 问卷调查
	DESK_PRODUCT_QUESTIONNAIRE: '/desk/product/quote/question/:vendorCode/:productCode',
	// 产品投保
	DESK_PRODUCT_QUOTE: '/desk/product/quote/:vendorCode/:productCode/:step',
	//产责险报价单只读页面
	QUOTATION_DETAILS_LIABILITY: '/desk/product/quote/liability/:quotationNo',
	//产责险保单只读页面
	POLICY_DETAILS_LIABILITY: '/desk/product/quote/liability/policy/:policyNo',
	// 保费通知书打印页面
	LIBILITY_PRINITING_PREMIUM:'/desk/product/quote/liability/priting/premium/:quotationNo',
	// //产责险报价单打印页面
	// LIBILITY_PRINITING_QUOTATION:'/desk/product/quote/liability/priting/quotation/:quotationNo',
	// // 海旅险报价单打印页面
	// GROUP_PRINITING_QUOTATION:'/desk/product/quote/grouptravel/priting/quotation/:quotationNo',
	//海旅险报价单只读页面
	DESK_PRODUCT_DETAILS_GROUP_TRAVEL: '/desk/product/quote/grouptravel/:quotationNo'

} as PATHS;
